import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('./pages/home-page/home-page.module').then(m => m.HomePageModule)
  },
  {
    path: 'items/:type',
    loadChildren: () => import('./pages/navigation/navigation.module').then(m => m.NavigationPageModule)
  },
  {
    path: 'e-commerce/:type',
    loadChildren: () => import('./pages/e-commerce/e-commerce.module').then(m => m.ECommercePageModule)
  },
  {
    path: 'media/:type',
    loadChildren: () => import('./pages/media/media.module').then(m => m.MediaPageModule)
  },
  {
    path: 'profile/:type',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'signup/:type',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'social/:type',
    loadChildren: () => import('./pages/social/social.module').then(m => m.SocialPageModule)
  },
  {
    path: 'walkthrought/:type',
    loadChildren: () => import('./pages/walkthrought/walkthrought.module').then(m => m.WalkthroughtPageModule)
  },
  {
    path: 'e-commerce/:type',
    loadChildren: () => import('./pages/e-commerce/e-commerce.module').then(m => m.ECommercePageModule)
  },
  {
    path: 'check box/:type',
    loadChildren: () => import('./pages/check-box/check-box.module').then(m => m.CheckBoxPageModule)
  },
  {
    path: 'toggle button/:type',
    loadChildren: () => import('./pages/toggle-button/toggle-button.module').then(m => m.ToggleButtonPageModule)
  },
  {
    path: 'radio button/:type',
    loadChildren: () => import('./pages/radio-button/radio-button.module').then(m => m.RadioButtonPageModule),
  },
  {
    path: 'lists/:type',
    loadChildren: () => import('./pages/lists/lists.module').then(m => m.ListsPageModule)
  },
  {
    path: 'other/:type',
    loadChildren: () => import('./pages/other/other.module').then(m => m.OtherPageModule)
  },
  {
    path: 'range/:type',
    loadChildren: () => import('./pages/range/range.module').then(m => m.RangePageModule)
  },
  {
    path: 'tab/:type',
    loadChildren: () => import('./pages/tab/tab.module').then(m => m.TabPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
